<template>
    <div>
        <v-menu offset-y open-on-hover v-for="item in items" :key="item.title">
            <template v-slot:activator="{ on, attrs }">
                <router-link
                    v-if="item.link"
                    style="text-decoration: none; color: inherit"
                    :to="{
                        name: item.link,
                        params: item.params ? item.params : {},
                    }"
                >
                    <v-btn
                        tag="a"
                        color="#cecece"
                        class="font-weight-medium font14 mx-1 px-3"
                        text
                        v-bind="attrs"
                        v-on="on"
                        dark
                        style="letter-spacing: 0"
                        :class="[item.link === $route.name ? 'v-item--active v-list-item--active' : '']"
                        @click="clear"
                    >
                        <v-icon v-if="item.icon" :color="item.iconColor" size="20px">
                            {{ item.icon }}
                        </v-icon>
                        <span :class="$vuetify.theme.dark ? 'whiteText' : 'blackText'" class="text-none">
                            {{ $t('menu.' + item.title) }}
                        </span>
                    </v-btn>
                </router-link>

                <v-btn tag="a" v-else color="#cecece" class="font-weight-medium font14 mx-1 px-3" text v-bind="attrs" v-on="on" dark style="letter-spacing: 0">
                    <span :class="$vuetify.theme.dark ? 'whiteText' : 'blackText'" class="text-none" v-if="$te('menu.' + item.title)">
                        {{ $t('menu.' + item.title) }}
                    </span>
                    <span class="text-none font-weight-bold" v-else>
                        {{ item.title }}
                    </span>
                    <v-icon small :color="$vuetify.theme.dark ? '' : 'black'">mdi-chevron-down</v-icon>
                </v-btn>
            </template>

            <v-list v-if="item.subItems" class="submenu pa-1 rounded" nav>
                <v-list-item-group v-model="selection[item.title]">
                    <div v-for="subItem in item.subItems" :key="subItem.title" class="pb-1" style="height: 36px">
                        <v-subheader
                            v-if="!subItem.link"
                            :class="$vuetify.theme.dark ? 'whiteText' : 'blackText'"
                            class="pl-2 font-weight-black text-uppercase"
                            style="height: 32px"
                        >
                            {{ $t('menu.' + subItem.title) }}
                        </v-subheader>
                        <router-link
                            v-else
                            :to="{
                                name: subItem.link,
                                params: subItem.params ? subItem.params : {},
                            }"
                            class="blackText"
                        >
                            <v-list-item class="" :class="[subItem.link === $route.name ? 'v-item--active v-list-item--active' : '']" @click="clear">
                                <v-list-item-content class="">
                                    <v-list-item-title :class="$vuetify.theme.dark ? 'whiteText' : 'blackText'" class="font-weight-medium">
                                        <v-icon v-if="subItem.icon" :color="subItem.iconColor" size="16px" class="mb-1">
                                            {{ subItem.icon }}
                                        </v-icon>
                                        {{ $t('menu.' + subItem.title) }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </router-link>
                        <v-divider v-if="subItem.divider" class="mt-1"></v-divider>
                    </div>
                </v-list-item-group>
            </v-list>
        </v-menu>
    </div>
</template>
<style scoped></style>
<script>
    export default {
        name: 'app-menuNav',

        props: {
            items: [],
        },

        created() {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {
            clear() {
                this.selection = [];
            },
        },

        computed: {
            selection: {
                get() {
                    return this.$store.getters['MenuModule/getSelection'];
                },
                set(value) {
                    this.$store.commit('MenuModule/setSelection', value);
                },
            },
        },
    };
</script>
